var router =require('pjax').Router;
var apiKeysForm = require('./form.js');
var apiKeysIndex = require('./index.js');

router.get('api-key/:any', apiKeysForm);
router.get('api-key', apiKeysIndex);
